<template>
  <el-dialog id="bb" class="dialogClass" :center="true" :close-on-click-modal="false" :title="!detail ? '修改客资信息' : '客资详情'"
    :visible.sync="showEdit" @close="closeEditDialog">
    <el-form>
      <el-form-item v-if="!detail" label="微信号：" label-width="100px">
        <el-input  v-model="customer.customerWx" autocomplete="off" type="text"></el-input>
      </el-form-item>
      <el-form-item v-if="detail" label="微信号：">
        <span>{{ customer.customerWx }}</span>
      </el-form-item>
      <el-form-item class="teacher" v-if="!detail" label="老师姓名：" label-width="100px" style="margin-top: 22px">
        <el-select placeholder="请选择教师" style="width: 100%;" v-model="customer.customerTeacherid"  clearable>
          <el-option style="margin-left: 10px;" v-for="teacher in teachers" :key="teacher.value" :label="teacher.label"
            :value="teacher.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="detail" label="所属地域：">
        <span>{{ customer.regionName === 1 ? '北京' : customer.regionName === 2 ? '深圳' : customer.regionName === 3 ? '上海' : '未知'}}</span>
      </el-form-item>
      <el-form-item  v-if="detail" label="渠道：">
        <span>{{ customer.channelType === 1 ? '线上' : customer.channelType === 2 ? '线下' : ''}}</span>
      </el-form-item>
      <el-form-item v-if="!detail" label="所属地域：" label-width="100px" style="margin-top: 22px">
        <el-select style="width: 100%;" v-model="customer.regionName "  clearable>
          <el-option style="margin-left: 10px;" v-for="customerSource in customerSourceIdss" :key="customerSource.id" :label="customerSource.dictValue" :value="customerSource.dictType"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="!detail" label="渠道：" label-width="100px" style="margin-top: 22px">
        <el-select style="width: 100%;" v-model="customer.channelType"  clearable>
          <el-option
            v-for="teacher in channelLsit"
            :key="teacher.dictType"
            :value="teacher.dictType"
            :label="teacher.dictValue">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="detail" label="老师姓名：" style="margin-top: -22px">
        <span v-if="customer.customerTeacherid === 1">小单老师</span>
        <span v-if="customer.customerTeacherid === 2">大单老师</span>
        <span v-if="customer.customerTeacherid === 3">刘老师</span>
        <span v-if="customer.customerTeacherid === 4">杨老师</span>
        <span v-if="customer.customerTeacherid === 5">线下老师</span>
      </el-form-item>
      <el-form-item v-if="!detail" style="margin-top: 22px" label="学生姓名：" label-width="100px">
        <el-input autocomplete="off" type="text" v-model="customer.customerStudent" size="small"
          placeholder="请输入学生姓名"></el-input>
      </el-form-item>
      <el-form-item label="微信添加状态：" style="margin-top: -22px" v-if="!detail">
        <el-radio-group  v-model="customer.customerState">
          <el-radio :label="1">新客</el-radio>
          <el-radio :label="2">通过</el-radio>
          <el-radio :label="3">未通过</el-radio>
          <el-radio :label="4">不存在</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="detail" label="微信添加状态：" style="margin-top: 22px">
        <span>{{ customer.customerState === 1 ? '新客' : (customer.customerState === 2 ? '通过' : (customer.customerState ===
          3 ? '未通过' : '不存在')) }}</span>
      </el-form-item>

      <el-form-item style="margin-top: -22px" v-if="detail" label="学生姓名：">
        <span>{{ customer.customerStudent }}</span>
      </el-form-item>
      <el-form-item v-if="!detail" label="客资来源：" label-width="100px">
        <el-select style="width: 100%;" v-model="customer.customerSource"  clearable>
          <el-option style="margin-left: 10px;" v-for="customerSource in customerSourceIds" :key="customerSource.sourceId"
            :label="customerSource.sourceName" :value="customerSource.sourceId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="margin-top: -22px" v-if="detail" label="客资来源：">
        <span v-if="customer.customerSource === 1">小红书</span>
        <span v-if="customer.customerSource === 2">视频号</span>
        <span v-if="customer.customerSource === 3">抖音</span>
      </el-form-item>
      <el-form-item v-if="!detail" label="添加方式：" label-width="100px">
        <el-radio-group v-model="customer.customerIsactive">
          <el-radio :label="1">主动</el-radio>
          <el-radio :label="2">被动</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="!detail" label="来源负责人：" label-width="100px">
        <el-select  style="width: 100%;" v-model="customer.customerSourcepeople" clearable>
          <el-option style="margin-left: 10px;" v-for="sourcePeople in sourcePeopleList"
            :key="sourcePeople.sourcepeopleId" :label="sourcePeople.sourcepeopleName"
            :value="sourcePeople.sourcepeopleId">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item style="margin-top: -22px" v-if="detail" label="来源负责人：">
        <span v-if="customer.customerSourcepeople === 1">bin</span>
        <span v-if="customer.customerSourcepeople === 2">小慈</span>
        <span v-if="customer.customerSourcepeople === 3">兰</span>
        <span v-if="customer.customerSourcepeople === 4">小五</span>
      </el-form-item>
      <el-form-item label="添加方式：" v-if="detail" style="margin-top: -22px">
        <span>{{ customerIsactive }}</span>
      </el-form-item>
      <el-form-item v-if="!detail" label="所属销售：" label-width="100px">
        <!-- <el-select placeholder="请选择所属销售" style="width: 100%;" v-model="customer.customerSale" clearable>
          <el-option style="margin-left: 10px;" v-for="customerSale in customerSales" :key="customerSale.saleId"
            :label="customerSale.saleName" :value="customerSale.saleId">
          </el-option>
        </el-select> -->

        <el-select v-model="customer.customerAccount" clearable filterable style="width: 100%;" placeholder="请选择所属销售">
              <el-option v-for="item in optionsList" :key="item.id" :label="item.label"   :value="item.id"></el-option>
        </el-select>

      </el-form-item>
      <el-form-item style="margin-top: -22px" v-if="detail" label="所属销售：">
        <!-- <span v-if="customer.customerSale === 1">杨老师</span>
        <span v-if="customer.customerSale === 2">苏老师</span> -->

        <el-select v-model="customer.customerAccount" clearable filterable style="width: 100%;" placeholder="请选择所属销售">
         <el-option v-for="item in optionsList" :key="item.id" :label="item.label"   :value="item.id"></el-option>
        </el-select>

      </el-form-item>
      <el-form-item v-if="!detail" label="成单状态：" label-width="100px">
        <el-radio-group v-model="customer.type" @input="handleChangeType(customer.type)">
          <el-radio :label="1">未成单</el-radio>
          <el-radio :label="2"
          >已成单</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item style="margin-top: -22px" v-if="detail" label="成单状态：">
        <span v-if="customer.type === 1">未成单</span>
        <span v-if="customer.type === 2">已成单</span>
      </el-form-item>

      <el-form-item style="margin-top: -22px" v-if="detail" label="客户需求：">
        <div style="margin: 10px 0px; width: 97%;border: 1px solid #ccc;padding: 10px 7px;margin-top: 20px;height: 180px;overflow-y: auto;border-radius: 5px;margin-left: 11px;">
          <div style="margin: 10px 0px;" v-for="(itme,index) in textareaJson" :key="index">{{ itme.remark }} {{ itme.remarkDate }} </div>
        </div>
      </el-form-item>


      <el-form-item style="margin-top: -22px" v-if="!detail" label="客户需求：">
        <div  style="margin: 10px 0px; width: 97%;border: 1px solid #ccc;padding: 10px 7px;margin-top: 20px;height: 180px;overflow-y: auto;border-radius: 5px;margin-left: 11px;">
          <div style="margin: 10px 0px;" v-for="(itme,index) in textareaJson" :key="index">{{ itme.remark }} {{ itme.remarkDate }} </div>
        </div>
        <el-input type="textarea"  style="width: 100%;margin: 10px;" placeholder="请输入客户需求" :autosize="{ minRows: 6, maxRows: 6 }"  v-model="newTextareaJson"  maxlength="99999999"  show-word-limit  > </el-input>
      </el-form-item>


    </el-form>
    <span slot="footer" class="dialog-footer"  v-if="!detail">
      <el-button @click="closeEditDialog">取消</el-button>
      <el-button type="primary" @click="saveEditForm">保存</el-button>
    </span>
    <span slot="footer" class="dialog-footer" v-if="detail">
      <el-button @click="closeEditDialog">关闭</el-button>
    </span>
  </el-dialog>
</template>
<script>
import axios from "axios";
import apiBaseUrl from '../../../config/api';
import { number } from "echarts/lib/export";
import OrderUpdate from "./OrderUpdate.vue";

export default {
  components: { OrderUpdate },
  data () {
    return {
      textareaJson: [],
      newTextareaJson: '',
      optionsList:[
        
      ],
      channelLsit:[
        {dictValue:"线上", dictType:1 },
        {dictValue:"线下", dictType:2 },
        {dictValue:"转介绍", dictType:3 },
      ],
      expireTimeOption: {
        disabledDate (date) {//disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
          return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        }
      },
      payTypes: [{
        value: 1,
        label: '现金'
      }, {
        value: 2,
        label: '微信'
      }, {
        value: 3,
        label: '支付宝'
      },
      {
        value: 4,
        label: '银行卡'
      },
      {
        value: 5,
        label: '公户'
      },
      {
        value: 6,
        label: '小鹅通'
      },
      {
        value: 7,
        label: '美团'
      },
      {
        value: 8,
        label: '公户（桑穆）'
      },
      {
        value: 9,
        label: '公户（博川）'
      },
      {
        value: 10,
        label: '公户（蒙正心理）'
      }
    ], // 付款渠道选项
      teacherName: '', //教师姓名
      customerIsactive: '',//添加状态
      sourceName: '', // 客资来源名称
      saleName: '',//所属销售名称
      sourcepeopleName: '', //来源负责人
      customerState: "", //选择的状态
      teachers: [
        {
          value: 1,
          label: '小单老师'
        },
        {
          value: 2,
          label: '大单老师'
        },
        {
          value: 3,
          label: '刘老师'
        },
        {
          value: 4,
          label: '杨老师'
        },
        {
          value: 5,
          label: '线下老师'
        }
      ], //；老师
      customerSourceIds: [], //客资来源id集合
      customerSourceIdss: [ {dictValue:"北京", dictType:1 },
      {dictValue:"深圳", dictType:2 },],
      sourcePeopleList: [], //来源负责人id集合
      customerSales: [], //所属销售
      detail: false,
      showEdit: false,
      customer: {
        customerIsactive: '',
        type: '',//成单状态
        customerId: '',
        customerWx: '', //微信号
        customerTeacherid: '', //教师id
        customerStudent: '', // 学生姓名
        customerSource: '', // 客资id
        customerSourcepeople: '', //来源负责人id
        customerAccount: '', //销售id
        customerState: '', //客资状态
        regionName: '',
        channelType:'',
      }
    }
  },
  created () {
    // this.fetchTeachers();
    this.fetchCustomerSourceIds();
    this.fetchSourcepeople();
    this.fetchCustomerSale();

    console.log("%c Line:196 🥟", "color:#ffdd4d",this.customer);

    axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,{ headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
      this.customerSourceIdss = res.data.data
    })
  },

  mounted () {
   this.optionsList = JSON.parse(sessionStorage.getItem('customersaleObj'))
  },
  methods: {
      getNowTime() {
        var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      hour = hour < 10 ? "0" + hour : hour;
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
    },
    //查询教师列表
    fetchTeachers () {
      axios
        .get(`${apiBaseUrl}/schedule/teacherlist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          this.teachers = response.data.data; // 将获取的数据赋值给teachers数组
        })
        .catch(error => {
          console.error(error);
        });
    },
    //查询客资来源列表
    fetchCustomerSourceIds () {
      axios
        .get(`${apiBaseUrl}/customerinformation/sourcelist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          this.customerSourceIds = response.data.data.list; // 将获取的数据赋值给teachers数组
        })
        .catch(error => {
          console.error(error);
        });
    },
    //查询所属销售列表
    fetchCustomerSale () {
      axios
        .get(`${apiBaseUrl}/customerinformation/customersale`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          this.customerSales = response.data.data.list; // 将获取的数据赋值给teachers数组
        })
        .catch(error => {
          console.error(error);
        });
    },
    //成单信息
    handleChangeType (type) {
      if (this.customer.customerState !== 2 && type === 2) {
        this.$message({
          dangerouslyUseHTMLString: true,
          message: '<span style="color:red;">请修改微信添加状态为已通过</span>',
          type: 'error',
        })
        this.customer.type = 1
      }
    },
    //查询来源负责人列表
    fetchSourcepeople () {
      axios
        .get(`${apiBaseUrl}/customerinformation/sourcepeoplelist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          this.sourcePeopleList = response.data.data.list; //
        })
        .catch(error => {
          console.error(error);
        });
    },
    isFull () {
      this.customer.stages = [{
        stagesMoney: '', // 分期金额
        stagesDate: '', // 分期时间
        payType: '', // 付款渠道
      }]
    },
    isNo () {
      this.customer.customerAllpaymoney = '';
      this.customer.customerAllpaytime = '';
      this.customer.payAlltype = '';
    },

    //初始化
    init (customerId, detail) {
      this.customerId = customerId;
      this.customer.customerId = customerId;
      this.detail = detail
      axios
        .get(
          `${apiBaseUrl}/customerinformation/customersone/${customerId}`
          ,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          this.customer.channelType = response.data.data.list.channelType ? response.data.data.list.channelType : ''
          this.customer.customerWx = response.data.data.list.customerWx; // 赋值
          this.customer.customerState = response.data.data.list.customerState
          this.customer.regionName = Number(response.data.data.list.regionName)
          this.customer.customerTeacherid = response.data.data.list.customerTeacherid;
          this.customer.customerSource = response.data.data.list.customerSource;
          this.customer.customerSourcepeople = response.data.data.list.customerSourcepeople;
          this.customer.customerIsactive = response.data.data.list.customerIsactive;


          
          if(response.data.data.list.clientNeedRemark){
            this.textareaJson = JSON.parse(response.data.data.list.clientNeedRemark);
          }else{
            this.textareaJson = [{}];
          }


          // if (response.data.data.list.customerSale !== 0) {
          //   this.customer.customerSale = response.data.data.list.customerSale;
          // }

          this.customer.customerAccount = response.data.data.list.customerAccount;

          this.customer.type = response.data.data.list.type;
          this.customer.customerStudent = response.data.data.list.customerStudent;
          this.teacherName = response.data.data.list.customerTeacherName;
          this.sourceName = response.data.data.list.sourceName;
          this.saleName = response.data.data.list.saleName;
          this.sourcepeopleName = response.data.data.list.sourcepeopleName;
          // this.customerIsactive=response.data.data.list.customerIsactive
          if (response.data.data.list.customerIsactive == "1") {
            this.customerIsactive = "主动"
          } else {
            this.customerIsactive = "被动"
          }
        })
        .catch(error => {
          console.error(error);
        });
      this.showEdit = true;
    },
    closeEditDialog () {
      this.showEdit = false
    },

    //保存按钮
    saveEditForm () {

    

      if (this.customer.type == "2" && this.customer.customerState !="2") {
      // if (this.customer.customerState != "2") {
        this.$message({
          message:"请修改微信添加状态为已通过",
          type:'error'
        })
        this.customer.type = 1
        return
      }

      let list = [];
      if(this.newTextareaJson){
        list = [{ remark: this.newTextareaJson, remarkDate: this.getNowTime() }];
        this.textareaJson.push(...list);
        this.customer.clientNeedRemark = JSON.stringify(this.textareaJson);
      }else{
        this.customer.clientNeedRemark = JSON.stringify(this.textareaJson);
      }

   
      axios
        .put(`${apiBaseUrl}/customerinformation/customerstudentupdate`, this.customer,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          if (response.data.code === 200) {
            this.$message({
              message: '修改成功',
              type: 'success'
            })
            this.newTextareaJson = '';
            this.showEdit = false;
            this.$emit("refresh")
          }
        })
        .catch(error => {
          this.$message({
            message: '修改失败',
            type: 'error'
          })
          console.error(error);
        });
    },
    //添加输入框
    addInput () {
      this.customer.stages.push({
        stagesMoney: '',
        stagesDate: '',
        payType: '', // 付款渠道
      })
    },
    //减少输入框
    removeItem () {
      if (this.customer.stages.length > 1) {
        this.customer.stages.pop()
      } else {
        this.customer.stages.splice(0, this.customer.stages.length)
      }
    },
  }
}
</script>
<style scoped>
/* 兼容移动端 */
@media screen and (max-width: 750px) {

  /* 兼容移动端 */
  #bb>>>.el-dialog {
    width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/manager/components/CustomerUpdOrDet.vue